/*------------------------------------*\
    COMPARISON SLIDER MODULE
\*------------------------------------*/
import ComparisonSlider from 'comparison-slider';

class Slider {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.slider = self.elem.querySelector('[data-slider]');

        new ComparisonSlider(self.slider);
    }
}

export default Slider;
